import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorageService } from 'angular-2-local-storage/dist/local-storage.service';
import { ImageAppFilterModel } from '../../../model/builk/image-app/image-app-filter.model';
import { ImageAppModel } from '../../../model/builk/image-app/image-app.model';
import { AuthenticationService } from '../../../service/api/auth/auth.service';
import { ImageAppService } from '../../../service/api/builk/image-app.service';
import { ImageAppAddComponent } from './image-app-add/image-app-add.component';
import { ImageAppConfirmUpdateStatusComponent } from './image-app-confirm-update-status/image-app-confirm-update-status.component';
import { ImageAppDetailComponent } from './image-app-detail/image-app-detail.component';

@Component({
  selector: 'app-ImageApp',
  templateUrl: './image-app.component.html',
  styleUrls: ['./image-app.component.scss']
})
export class ImageAppComponent implements OnInit {
  // using for page list (default)
  page: number = 1;
  lastPage: number = 1;
  limit: number = 5;
  countAll: number = 0;
  canActive: boolean = false;
  imageApp: Array<ImageAppModel> = [];
  filter: ImageAppFilterModel = new ImageAppFilterModel();
  search: string = "";

  @ViewChild("addImageModal") addImageModal: ImageAppAddComponent;
  @ViewChild("confirm") confirm: ImageAppConfirmUpdateStatusComponent;
  @ViewChild("detailModal") detailModal: ImageAppDetailComponent
;
  constructor(
    private readonly router: Router,
    private readonly localStorageService: LocalStorageService,
    private readonly AuthService: AuthenticationService,
    private readonly ImageAppService: ImageAppService
  ) { }

  ngOnInit() {
    this.getImageApp();
  }
  getImageApp() {
    this.filter.skip = ((this.page - 1) * 5);
    this.filter.take = this.limit;

    this.filter.search = this.search;


    this.ImageAppService.getImageAppBackOffice(this.filter)
      .subscribe(
        Response => {
          console.log(Response);
          this.imageApp = Response.images;
          this.countAll = Response.count;
          this.lastPage = Math.ceil((Response.count) / (this.limit));
          this.canActive = Response.canActive;
        },
        err => {
          // unauthorized refresh token
          console.log("unauth");
          if (err.status === 401) {
            this.AuthService.refreshSessionToken()
              .subscribe(
                Response => {
                  // Update session
                  this.localStorageService.set("accessToken", Response.authenticationResult.accessToken);

                  this.localStorageService.set("expiresTime", (Date.now() / 1000) + Response.authenticationResult.expiresIn);
                }
              );
            this.getImageApp();
          } else {
            this.router.navigate(["/home"]);
          }
        }
      );
  }
  backPage(): void {
    if (this.page > 1) {
      this.page--;
    }
    this.getImageApp();
  }

  nextPage(): void {
    if (this.page < this.lastPage) {
      this.page++;
    }
    this.getImageApp();
  }

  goTofirstPage(): void {
    if (this.page > 1) {
      this.page = 1;
    }
    this.getImageApp();
  }

  goTolastPage(): void {
    if (this.page < this.lastPage) {
      this.page = this.lastPage;
    }
    this.getImageApp();
  }

  addImage () {
    this.addImageModal.openModal();
  }

  
  onConfirmStatus(imageAppSurrKey: number, active: boolean) {
    this.confirm.openModal(imageAppSurrKey, active);
  }

  refreshPage() {
    this.goTofirstPage();
  }

  detailImage (imageAppSurrKey: number, link: string, name: string, imageUrl: string) {
    this.detailModal.openModal(name, link, imageAppSurrKey, imageUrl);
  }

  seachImageApp (){
    this.page = 1;
    this.getImageApp();
  }
}
